/**
 * cookie utils
 *
 * @description 相对原始写法，兼容ie
 * @author Shigq
 * @date 2021/11/9 11:11
 */

/* todo methods */
/**
 * set cookie
 *
 * @param name
 * @param value
 */
function setCookie(name, value, expires, path, domain, secure) {
	var cookieToday = new Date();

	expires = expires || new Date(cookieToday.getTime() + (1 * 60 * 60 * 24 * 1000));
	// expires = expires || new Date(cookieToday.getTime() + (10 * 1000));
	path = path || '/'
	domain = domain || window.location.hostname
	value = escape(value)

	document.cookie = name + '=' + value +
		((expires) ? '; expires=' + expires.toGMTString() : '') +
		((path) ? '; path=' + path : '') +
		((domain) ? '; domain=' + domain : '') +
		((secure) ? '; secure' : '')
}

/**
 * get cookie
 *
 * @param name
 * @returns {*}
 */
function getCookie(name) {
	var search = name + '='
	if (document.cookie.length > 0) { // if there are any cookies
		var offset = document.cookie.indexOf(search)
		if (offset != -1) { // if cookie exists
			offset += search.length
			// set index of beginning of value
			var end = document.cookie.indexOf(';', offset)
			// set index of end of cookie value
			if (end == -1) end = document.cookie.length
			return unescape(document.cookie.substring(offset, end))
		}
	}
}

/**
 * delete cookie
 *
 * @param name
 */
function delCookie(name, path, domain) {
	if (getCookie(name)) {
		document.cookie = name + '=' +
			((path) ? '; path=' + path : '') +
			((domain) ? '; domain=' + domain : '') +
			';expires=Thu, 01-Jan-70 00:00:01 GMT'
	}
}

module.exports = {
	setCookie,
	getCookie,
	delCookie
}
